import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * MainGridRowHeaderSummaryPachi
 */
class MainGridRowSummaryPachi extends React.Component {

  constructor(props) {
    super(props);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.createGridValue = this.createGridValue.bind(this);
  }

  handleLinkClick(event, kisyuCd) {
    event.preventDefault();
    event.stopPropagation();
    commonLogic.handleUsedMachinePriceClick(event, kisyuCd);
  }

  /**
   * グリッド値作成
   * @param {*} targetHeaderItem
   * @returns
   */
  createGridValue(targetHeaderItem) {
    let targetValue = this.props.gridData[targetHeaderItem.koumokuKey];
    let decimalPoint = targetHeaderItem.decimalPoint;

    let node = null;
    // 中古価格の場合
    if (targetHeaderItem.key == 'used_machine_price') {
      let s = '-';
      let style = null;
      if (targetValue !== '' && targetValue !== 0) {
        s = commonLogic.numberFormat(targetValue, decimalPoint);
        if (parseFloat(style) < 0) {
          style = 'minus_value';
        }
      }
      // 中古価格の機種コード(p-sensor機種コード)
      let kisyuCd = '';
      const psensorInfo = this.props.gridData['p_sensor'];
      if (psensorInfo !== undefined) {
        kisyuCd = psensorInfo.kisyu_cd;
      }

      if (s != '-') {
        node = (
          <a className={`used_machine_price ${style}`} href="#" onClick={(event) => { this.handleLinkClick(event, kisyuCd); }}>&yen;{s}</a>
        );
      } else {
        node = (
          <a className="used_machine_price" href="#" onClick={(event) => { this.handleLinkClick(event, kisyuCd); }}>{s}</a>
        );
      }

      return node;
    }

    // 中古価格増減
    if (targetHeaderItem.key == 'zogen_used_machine_price') {
      // 中古価格増減
      let s = '-';
      if (targetValue !== '') {
        if (targetValue != undefined && targetValue != 0) {
          s = commonLogic.numberFormat(targetValue, decimalPoint);
          if (0 < parseInt(s.replace(/,/g, ''), 10)) {
            s = '+' + s;
          }
        } else {
          s = String(0);
        }
      }

      if (s === '-') return (<span>{s}</span>);
      if (s.startsWith('+')) return (<span>+&yen;{s.slice(1)}</span>);
      if (s.startsWith('-')) return (<span className="minus_value">-&yen;{s.slice(1)}</span>);

      return (<span className="noto-sans-text">&plusmn;&yen;{s}</span>);
    }


    if (decimalPoint != null) {
      let s = commonLogic.numberFormat(targetValue, decimalPoint);
      if (s.match('-') && s != '-') {
        node = (<span className="minus_value">{s}</span>);
      } else {
        node = (<span>{s}</span>);
      }
    } else {
      node = (<span>{targetValue}</span>);
    }


    return node;
  }

  render() {
    const Nodes = this.props.gridHeaderInfo.map((item) => {

      return (
        <div className="grid_item_detail">
          <div className="col_koumoku_header" key={item.id}>
            <p className="nh">{item.name}</p>
          </div>
          <div className="col_koumoku_body" >
            {this.createGridValue(item)}
          </div>
        </div>
      );
    });


    return (
      <div className="grid_row_content_summary">
        {Nodes}
      </div>
    );
  }
}

MainGridRowSummaryPachi.propTypes = {
  gridHeaderInfo: PropTypes.any.isRequired,
  gridData: PropTypes.any.isRequired,
};

export default MainGridRowSummaryPachi;
